
import { Component, Vue } from "vue-property-decorator";
import Util from "@/lib/util";
import Pagination from "@/components/Pagination/index.vue";
import { PromotionalOrderService, PromotionalOrderDto } from "@/api/service-proxies";
import uploadTracking from '../components/UploadtrackingDialog.vue'

import returnsDialog from '../components/ReturnsDialog.vue'

import PagedListBase, {
  PagedRequestDto
} from "@/lib/view-base/paged-list-base";
import { Result, Row } from "element-ui";

class TenantPagedRequest extends PagedRequestDto {
  orderNumber!: string;
  code!: string;
  companyNumber!: string;
  ReceName!: string;
  ReceMobile!: string;
  createTime!: moment.Moment;
  createTime2!: moment.Moment;
  list = [];
  OrderRecordState:number
}

@Component({
  name: "Tenant",
  components: {
    Pagination,
    uploadTracking,
    returnsDialog
  }
})
export default class Tenant extends PagedListBase<
  TenantPagedRequest,
  PromotionalOrderDto
> {
  request = new TenantPagedRequest();
  name = ''
  OderService = new PromotionalOrderService();
  value2 = null
  // 搜索商品类型
  optionsType:any = [];
  pickerOptions = {
    shortcuts: [{
      text: '最近一周',
      onClick(picker) {
        const end = new Date();
        const start = new Date();
        start.setTime(start.getTime() - 3600 * 1000 * 24 * 7);
        picker.$emit('pick', [start, end]);
      }
    }, {
      text: '最近一个月',
      onClick(picker) {
        const end = new Date();
        const start = new Date();
        start.setTime(start.getTime() - 3600 * 1000 * 24 * 30);
        picker.$emit('pick', [start, end]);
      }
    }, {
      text: '最近三个月',
      onClick(picker) {
        const end = new Date();
        const start = new Date();
        start.setTime(start.getTime() - 3600 * 1000 * 24 * 90);
        picker.$emit('pick', [start, end]);
      }
    }]
  }

  created() {
    this.refresh();
  }

  getpage(finishCallback: Function): void {
    this.OderService
      .getAll(
        this.request.orderNumber,
        this.request.OrderRecordState,
        this.request.companyNumber,
        this.request.ReceName,
        this.request.ReceMobile,
        this.request.createTime,
        this.request.createTime2,
        this.request.sorting,
        this.request.skipCount,
        this.request.maxResultCount
      )
      .then(result => {
        result.items.forEach((e)=>{
          if( e.product != null){
            e.product.p_Path = (this as any).$aes.imgAddAuth(e.product.p_Path);
          }
        })
        this.list = result.items;
        this.showPaging(result);

      })
      .finally(() => {
        finishCallback();
      });
  }




  dateTimeChange(event: any) {
    if (event) {
      this.request.createTime = event[0];
      this.request.createTime2 = event[1];
    } else {
      this.request.createTime = null;
      this.request.createTime2 = null;
    }
  }


}
